<form fxLayout="column" fxLayoutGap="20px" [formGroup]="datiAnaForm" #form>
  <ng-container *ngIf="dataService.prodotto?.tipo_utenza == 'BUS'">
    <div class="tipo-cliente">
      <mat-radio-group formControlName="tipoCliente" fxLayoutGap="10px" (change)="setCliente()">
        <mat-radio-button value="0">Business</mat-radio-button>
        <mat-radio-button value="1">Condominio</mat-radio-button>
      </mat-radio-group>
    </div>

    <div>
      <h3 class="no-margin title-section">
        {{datiAnaForm.get('tipoCliente')?.value == '0' ? 'Azienda':'Condominio'}}
      </h3>
    </div>
    <form formGroupName="aziendaCondominio">
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field>
          <input [required]="setRequired(aziendaCondominio.get('ragioneSociale'))" matInput placeholder="Ragione sociale" formControlName="ragioneSociale">
          <mat-error *ngIf="aziendaCondominio.controls.ragioneSociale.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-select [required]="setRequired(aziendaCondominio.get('formaGiuridica'))" placeholder="Forma giuridica" formControlName="formaGiuridica" name="item">
            <mat-option *ngFor="let item of formeGiuridiche" [value]="item.code">
              {{item.value}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="aziendaCondominio.get('formaGiuridica')?.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(aziendaCondominio.get('piva'))" matInput placeholder="Partita IVA" formControlName="piva" [maxLength]="11">
          <mat-error *ngIf="aziendaCondominio.controls.piva.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
          <mat-error *ngIf="aziendaCondominio.controls.piva.hasError('minlength')">
            <strong>Lunghezza errata</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(aziendaCondominio.get('codiceFiscale'))" matInput placeholder="Codice fiscale" formControlName="codiceFiscale" oninput="this.value = this.value.toUpperCase()"
            [maxlength]="cfAziendaCondominio">
          <mat-error *ngIf="aziendaCondominio.controls.codiceFiscale.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
          <mat-error *ngIf="aziendaCondominio.controls.codiceFiscale.hasError('invalid')">
            <strong>Composizione errata</strong>
          </mat-error>
          <mat-error *ngIf="aziendaCondominio.controls.codiceFiscale.hasError('minlength') || aziendaCondominio.controls.codiceFiscale.hasError('maxlength')">
            <strong>Lunghezza errata</strong>
          </mat-error>
          <mat-error *ngIf="aziendaCondominio.controls.codiceFiscale.hasError('pattern')">
            <strong>Pattern errato</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </form>

    <ng-container *ngIf="dataService.prodotto?.tipo_utenza == 'BUS' && datiAnaForm.get('tipoCliente')?.value == '0' && dataService.user == 3">
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
        <div>
          <h2 class="divider-title">
            Cerved *
          </h2>
        </div>
        <mat-divider fxFlex="auto"></mat-divider>
      </div>
      <cerved [cervedForm]="cervedForm"></cerved>
    </ng-container>

    <!-- <ng-container *ngIf="dataService.prodotto?.cod_tipo_fornitura_id != 'GAS'">
      <div *ngIf="datiAnaForm.get('tipoCliente')!.value == '0'" fxLayout="column wrap" fxLayoutGap="20px">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <div fxFlex="auto">
            <h3>
              <strong>Numero di dipendenti</strong> *
            </h3>
            <mat-radio-group formControlName="numeroDipendenti" fxLayout="column" fxLayoutGap="10px">
              <mat-radio-button value="0">Inferiore a 10</mat-radio-button>
              <mat-radio-button value="1">Compreso tra i 10 e i 50</mat-radio-button>
              <mat-radio-button value="2">Superiore ai 50</mat-radio-button>
            </mat-radio-group>
          </div>
          <div fxFlex="auto">
            <h3>
              <strong>Fatturato annuo o un totale di bilancio</strong> *
            </h3>
            <mat-radio-group formControlName="fatturato" fxLayout="column" fxLayoutGap="10px">
              <mat-radio-button value="0">Inferiore a 2 Milioni di Euro</mat-radio-button>
              <mat-radio-button value="1">Compreso fra 2 e 10 Milioni di Euro</mat-radio-button>
              <mat-radio-button value="2">Superiore a 10 Milioni di Euro</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div>
          <div fxFlex="auto">
            <h3>
              <strong>Punti di prelievo su territorio nazionale</strong> *
            </h3>
            <mat-radio-group formControlName="tipoPuntiPrelievo" fxLayout="column" fxLayoutGap="10px">
              <mat-radio-button value="0">Tutti in bassa tensione</mat-radio-button>
              <mat-radio-button value="2">Almeno un punto in media o alta tensione</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </ng-container> -->

    <div *ngIf="datiAnaForm.get('tipoCliente')!.value == '1'" fxLayout="column" fxLayoutGap="20px">
      <h2 class="title-section">Amministratore</h2>
      <form formGroupName="amministratore">
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
          <mat-form-field>
            <input [required]="setRequired(amministratore.get('nome'))" matInput placeholder="Nome" formControlName="nome">
            <mat-error *ngIf="amministratore.controls.nome.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input [required]="setRequired(amministratore.get('cognome'))" matInput placeholder="Cognome" formControlName="cognome">
            <mat-error *ngIf="amministratore.controls.cognome.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.sm="column wrap" fxLayoutAlign.sm="start start" fxLayoutGap.sm="10px" class="cf-row">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
            <mat-form-field>
              <input [required]="setRequired(amministratore.get('codiceFiscale'))" matInput placeholder="Codice fiscale" formControlName="codiceFiscale" oninput="this.value = this.value.toUpperCase()"
                #cfAmm>
              <mat-error *ngIf="amministratore.controls.codiceFiscale.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
              <mat-error *ngIf="amministratore.controls.codiceFiscale.hasError('invalid')">
                <strong>Composizione errata</strong>
              </mat-error>
              <mat-error *ngIf="amministratore.controls.codiceFiscale.hasError('minlength') || amministratore.controls.codiceFiscale.hasError('maxlength')">
                <strong>Lunghezza errata</strong>
              </mat-error>
              <mat-error *ngIf="amministratore.controls.codiceFiscale.hasError('pattern')">
                <strong>Pattern errato</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <div fxLayout="column" fxLayoutGap="10px" class="div-cf-straniero">
            <h3>CF straniero</h3>
            <mat-radio-group fxLayout="row" fxLayoutGap="10px" formControlName="cfStraniero">
              <mat-radio-button value="0">No</mat-radio-button>
              <mat-radio-button value="1">Si</mat-radio-button>
            </mat-radio-group>
          </div>
          <button type="button" mat-raised-button color="primary" fxLayoutAlign="center center" [matMenuTriggerFor]="altriDati">
            Calcola
          </button>
          <mat-menu #altriDati="matMenu">
            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" class="margin-20" (click)="$event.stopPropagation()" (keydown.Tab)="$event.stopPropagation()">
              <p class="cf-alert">Aggiungi i dati sottostanti per calcolare il codice fiscale</p>
              <mat-form-field>
                <mat-select placeholder="Sesso" formControlName="sesso" [required]="setRequired(amministratore.get('sesso'))">
                  <mat-option value="M">
                    M
                  </mat-option>
                  <mat-option value="F">
                    F
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="amministratore.controls.sesso.hasError('required')">
                  <strong>Campo obbligatorio</strong>
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <bw-autocomplete [required]="setRequired(amministratore.get('comuneDiNascita'))" placeholder="Comune di nascita" formControlName="comuneDiNascita" [source]="comuni$"
                  valueMember="id_comune" displayMember="comune" secondLineMember="secondLineFn">
                </bw-autocomplete>
                <mat-error *ngIf="amministratore.controls.comuneDiNascita.hasError('required')">
                  <strong>Campo obbligatorio</strong>
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Data di nascita</mat-label>
                <input [required]="setRequired(amministratore.get('dataDiNascita'))" matInput [matDatepicker]="dataDiNascitapicker" formControlName="dataDiNascita">
                <mat-error *ngIf="amministratore.controls.dataDiNascita.hasError('required')">
                  <strong>Campo obbligatorio</strong>
                </mat-error>
                <mat-datepicker-toggle matSuffix [for]="dataDiNascitapicker"></mat-datepicker-toggle>
                <mat-datepicker #dataDiNascitapicker></mat-datepicker>
              </mat-form-field>
            </div>
          </mat-menu>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <mat-form-field fxFlex="25">
            <!-- <input [required]="setRequired(amministratore.get('tipoDocIdentica'))" matInput
                        placeholder="Tipo documento di identità" formControlName="tipoDocIdentica"> -->
            <mat-select [required]="setRequired(amministratore.get('tipoDocIdentica'))" matInput placeholder="Tipo documento di identità" formControlName="tipoDocIdentica">
              <mat-option value="CI">Carta Identità</mat-option>
              <mat-option value="PA">Patente</mat-option>
              <mat-option value="PE">Permesso Soggiorno</mat-option>
              <mat-option value="PP">Passaporto</mat-option>
            </mat-select>
            <mat-error *ngIf="amministratore.controls.tipoDocIdentica.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input [required]="setRequired(amministratore.get('nDocIdentica'))" matInput placeholder="Numero documento" formControlName="nDocIdentica">
            <mat-error *ngIf="amministratore.controls.nDocIdentica.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div fxFlex="none" fxLayoutGap="5px" formGroupName="cellulare">
            <mat-form-field fxFlex="50px">
              <mat-label>Prefisso</mat-label>
              <input [required]="setRequired(amministratore.get('cellulare')?.get('prefisso'))" matInput placeholder="0039" formControlName="prefisso" maxlength="4">
              <mat-error *ngIf="amministratore.controls.cellulare.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
              <mat-error *ngIf="amministratore.controls.cellulare.hasError('minlength') || amministratore.controls.cellulare.hasError('maxlength')">
                <strong>Lunghezza errata</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="none">
              <input [required]="setRequired(amministratore.get('cellulare')?.get('numero'))" matInput placeholder="Cellulare" formControlName="numero" maxlength="10">
              <mat-error *ngIf="amministratore.controls.cellulare.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
              <mat-error *ngIf="amministratore.controls.cellulare.hasError('minlength') || amministratore.controls.cellulare.hasError('maxlength')">
                <strong>Lunghezza errata</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <mat-form-field>
            <input [required]="setRequired(amministratore.get('telefono'))" matInput placeholder="Telefono" formControlName="telefono" maxlength="11">
            <mat-error *ngIf="amministratore.controls.telefono.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>

    <div *ngIf="datiAnaForm.get('tipoCliente')!.value == '0'" fxLayout="column" fxLayoutGap="20px">
      <h2 class="title-section">Rappresentante legale</h2>
      <form formGroupName="rappLegale">
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
          <mat-form-field>
            <input [required]="setRequired(rappLegale.get('nome'))" matInput placeholder="Nome" formControlName="nome">
            <mat-error *ngIf="rappLegale.controls.nome.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <input [required]="setRequired(rappLegale.get('cognome'))" matInput placeholder="Cognome" formControlName="cognome">
            <mat-error *ngIf="rappLegale.controls.cognome.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.sm="column wrap" fxLayoutAlign.sm="start start" fxLayoutGap.sm="10px" class="cf-row">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
            <mat-form-field>
              <input [required]="setRequired(rappLegale.get('codiceFiscale'))" matInput placeholder="Codice fiscale" formControlName="codiceFiscale" oninput="this.value = this.value.toUpperCase()"
                #cfAmm>
              <mat-error *ngIf="rappLegale.controls.codiceFiscale.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
              <mat-error *ngIf="rappLegale.controls.codiceFiscale.hasError('invalid')">
                <strong>Composizione errata</strong>
              </mat-error>
              <mat-error *ngIf="rappLegale.controls.codiceFiscale.hasError('minlength') || rappLegale.controls.codiceFiscale.hasError('maxlength')">
                <strong>Lunghezza errata</strong>
              </mat-error>
              <mat-error *ngIf="rappLegale.controls.codiceFiscale.hasError('pattern')">
                <strong>Pattern errato</strong>
              </mat-error>
            </mat-form-field>
            <div fxLayout="column" fxLayoutGap="10px" class="div-cf-straniero">
              <h3>CF straniero</h3>
              <mat-radio-group fxLayout="row" fxLayoutGap="10px" formControlName="cfStraniero">
                <mat-radio-button value="0">No</mat-radio-button>
                <mat-radio-button value="1">Si</mat-radio-button>
              </mat-radio-group>
            </div>
            <button type="button" mat-raised-button color="primary" fxLayoutAlign="center center" [matMenuTriggerFor]="altriDati">
              Calcola
            </button>
            <mat-menu #altriDati="matMenu">
              <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" class="margin-20" (click)="$event.stopPropagation()" (keydown.Tab)="$event.stopPropagation()">
                <p class="cf-alert">Aggiungi i dati sottostanti per calcolare il codice fiscale</p>
                <mat-form-field>
                  <mat-select placeholder="Sesso" formControlName="sesso" [required]="setRequired(rappLegale.get('sesso'))">
                    <mat-option value="M">
                      M
                    </mat-option>
                    <mat-option value="F">
                      F
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="rappLegale.controls.sesso.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <bw-autocomplete [required]="setRequired(rappLegale.get('comuneDiNascita'))" placeholder="Comune di nascita" formControlName="comuneDiNascita" [source]="comuni$"
                    valueMember="id_comune" displayMember="comune" secondLineMember="secondLineFn">
                  </bw-autocomplete>
                  <mat-error *ngIf="rappLegale.controls.comuneDiNascita.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Data di nascita</mat-label>
                  <input [required]="setRequired(rappLegale.get('dataDiNascita'))" matInput [matDatepicker]="dataDiNascitapicker" formControlName="dataDiNascita">
                  <mat-error *ngIf="rappLegale.controls.dataDiNascita.hasError('required')">
                    <strong>Campo obbligatorio</strong>
                  </mat-error>
                  <mat-datepicker-toggle matSuffix [for]="dataDiNascitapicker"></mat-datepicker-toggle>
                  <mat-datepicker #dataDiNascitapicker></mat-datepicker>
                </mat-form-field>
              </div>
            </mat-menu>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div fxFlex="none" fxLayoutGap="5px" formGroupName="cellulare">
            <mat-form-field fxFlex="50px">
              <mat-label>Prefisso</mat-label>
              <input [required]="setRequired(rappLegale.get('cellulare')?.get('prefisso'))" matInput placeholder="0039" formControlName="prefisso" maxlength="4">
              <mat-error *ngIf="rappLegale.controls.cellulare.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
              <mat-error *ngIf="rappLegale.controls.cellulare.hasError('minlength') || rappLegale.controls.cellulare.hasError('maxlength')">
                <strong>Lunghezza errata</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="none">
              <input [required]="setRequired(rappLegale.get('cellulare')?.get('numero'))" matInput placeholder="Cellulare" formControlName="numero" maxlength="10">
              <mat-error *ngIf="rappLegale.controls.cellulare.hasError('required')">
                <strong>Campo obbligatorio</strong>
              </mat-error>
              <mat-error *ngIf="rappLegale.controls.cellulare.hasError('minlength') || rappLegale.controls.cellulare.hasError('maxlength')">
                <strong>Lunghezza errata</strong>
              </mat-error>
            </mat-form-field>
          </div>
          <mat-form-field>
            <input [required]="setRequired(rappLegale.get('telefono'))" matInput placeholder="Telefono" formControlName="telefono" maxlength="11">
            <mat-error *ngIf="rappLegale.controls.telefono.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>

  </ng-container>
  <ng-container *ngIf="dataService.prodotto?.tipo_utenza == 'DOM'">
    <!-- <ng-container *ngIf="dataService.user != 2">
            <mat-form-field appearance="fill">
                <bw-autocomplete placeholder="Ricerca un cliente esistente"
                    [source]="clienti$" valueMember="id_cliente" displayMember="ragione_sociale"
                    [secondLineMember]="secondLineFnCliente" (optionSelectedEvent)="clienteSelected($event)">
                </bw-autocomplete>
            </mat-form-field>
        </ng-container> -->
    <h2 class="title-section">Cliente</h2>
    <form formGroupName="cliente" fxLayout="column" fxLayoutGap="10px">
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field>
          <input [required]="setRequired(cliente.get('nome'))" matInput placeholder="Nome" formControlName="nome">
          <mat-error *ngIf="cliente.controls.nome.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(cliente.get('cognome'))" matInput placeholder="Cognome" formControlName="cognome">
          <mat-error *ngIf="cliente.controls.cognome.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="20px" fxLayout.sm="column wrap" fxLayoutAlign.sm="start start" fxLayoutGap.sm="10px" class="cf-row">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
          <mat-form-field>
            <input [required]="setRequired(cliente.get('codiceFiscale'))" matInput placeholder="Codice fiscale" formControlName="codiceFiscale" oninput="this.value = this.value.toUpperCase()" #cfCli>
            <mat-error *ngIf="cliente.controls.codiceFiscale.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
            <mat-error *ngIf="cliente.controls.codiceFiscale.hasError('invalid')">
              <strong>Composizione errata</strong>
            </mat-error>
            <mat-error *ngIf="cliente.controls.codiceFiscale.hasError('minlength') || cliente.controls.codiceFiscale.hasError('maxlength')">
              <strong>Lunghezza errata</strong>
            </mat-error>
            <mat-error *ngIf="cliente.controls.codiceFiscale.hasError('pattern')">
              <strong>Pattern errato</strong>
            </mat-error>
          </mat-form-field>
          <div fxLayout="column" fxLayoutGap="10px" class="div-cf-straniero">
            <h3>CF straniero</h3>
            <mat-radio-group fxLayout="row" fxLayoutGap="10px" formControlName="cfStraniero">
              <mat-radio-button value="0">No</mat-radio-button>
              <mat-radio-button value="1">Si</mat-radio-button>
            </mat-radio-group>
          </div>
          <button type="button" mat-raised-button color="primary" fxLayoutAlign="center center" [matMenuTriggerFor]="altriDati">
            Calcola
          </button>
          <mat-menu #altriDati="matMenu">
            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px" class="margin-20" (click)="$event.stopPropagation()" (keydown.Tab)="$event.stopPropagation()">
              <p class="cf-alert">Aggiungi i dati sottostanti per calcolare il codice fiscale</p>
              <mat-form-field>
                <mat-select placeholder="Sesso" formControlName="sesso" [required]="setRequired(cliente.get('sesso'))">
                  <mat-option value="M">
                    M
                  </mat-option>
                  <mat-option value="F">
                    F
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="cliente.controls.sesso.hasError('required')">
                  <strong>Campo obbligatorio</strong>
                </mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="30">
                <bw-autocomplete [required]="setRequired(cliente.get('comuneDiNascita'))" placeholder="Comune di nascita" formControlName="comuneDiNascita" [source]="comuni$" valueMember="id_comune"
                  displayMember="comune" secondLineMember="secondLineFn">
                </bw-autocomplete>

                <mat-error *ngIf="cliente.controls.comuneDiNascita.hasError('required')">
                  <strong>Campo obbligatorio</strong>
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Data di nascita</mat-label>
                <input [required]="setRequired(cliente.get('dataDiNascita'))" matInput [matDatepicker]="dataDiNascitapicker" formControlName="dataDiNascita">
                <mat-error *ngIf="cliente.controls.dataDiNascita.hasError('required') && !cliente.controls.dataDiNascita.hasError('matDatepickerParse')">
                  <strong>Campo obbligatorio</strong>
                </mat-error>
                <mat-error *ngIf="cliente.controls.dataDiNascita.hasError('matDatepickerParse')">
                  <strong>Formato data errato</strong>
                </mat-error>
                <mat-datepicker-toggle matSuffix [for]="dataDiNascitapicker"></mat-datepicker-toggle>
                <mat-datepicker #dataDiNascitapicker></mat-datepicker>
              </mat-form-field>
            </div>
          </mat-menu>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div fxFlex="none" fxLayoutGap="5px" formGroupName="cellulare">
          <mat-form-field fxFlex="50px">
            <mat-label>Prefisso</mat-label>
            <input [required]="setRequired(cliente.get('cellulare')?.get('prefisso'))" matInput placeholder="0039" formControlName="prefisso" maxlength="4">
            <mat-error *ngIf="cliente.get('cellulare')?.get('prefisso')?.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
            <mat-error *ngIf="cliente.get('cellulare')?.get('prefisso')?.hasError('minlength') || cliente.get('cellulare')?.get('prefisso')?.hasError('maxlength')">
              <strong>Lunghezza errata</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="none">
            <input [required]="setRequired(cliente.get('cellulare')?.get('numero'))" matInput placeholder="Cellulare" formControlName="numero" maxlength="10">
            <mat-error *ngIf="cliente.get('cellulare')?.get('numero')?.hasError('required')">
              <strong>Campo obbligatorio</strong>
            </mat-error>
            <mat-error *ngIf="cliente.get('cellulare')?.get('numero')?.hasError('minlength') || cliente.get('cellulare')?.get('numero')?.hasError('maxlength')">
              <strong>Lunghezza errata</strong>
            </mat-error>
          </mat-form-field>
        </div>

        <mat-form-field>
          <input [required]="setRequired(cliente.get('telefono'))" matInput placeholder="Telefono" formControlName="telefono" maxlength="11">
          <mat-error *ngIf="cliente.controls.telefono.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-form-field>
          <mat-select [required]="setRequired(cliente.get('tipoDocIdentica'))" matInput placeholder="Tipo documento di identità" formControlName="tipoDocIdentica">
            <mat-option value="CI">Carta Identità</mat-option>
            <mat-option value="PA">Patente</mat-option>
            <mat-option value="PE">Permesso Soggiorno</mat-option>
            <mat-option value="PP">Passaporto</mat-option>
          </mat-select>
          <mat-error *ngIf="cliente.controls.tipoDocIdentica.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input [required]="setRequired(cliente.get('nDocIdentica'))" matInput placeholder="Numero documento" formControlName="nDocIdentica">
          <mat-error *ngIf="cliente.controls.nDocIdentica.hasError('required')">
            <strong>Campo obbligatorio</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </form>
  </ng-container>

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
    <div>
      <h2 class="divider-title">
        Indirizzo sede legale
      </h2>
    </div>
    <mat-divider fxFlex="auto"></mat-divider>
  </div>

  <app-indirizzo [indirizzoForm]="indirizzoForm"></app-indirizzo>

  <ng-container>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="30px">
      <div>
        <h2 class="divider-title">
          Privacy
        </h2>
      </div>
      <mat-divider fxFlex="auto"></mat-divider>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="20px" class="privacy">
      <div #scrollable class="scroller">
        <div class="container">
          <p align="center">
            <b>
              <i>
                <span>Ai sensi e per gli effetti dell'art. 13 del Regolamento UE 2016/679 (di seguito &#8220;GDPR&#8221;) relativo alla protezione delle
                  persone fisiche con riguardo al trattamento dei dati personali</span>
              </i>
            </b>
            <span>.</span>
          </p>
          <p>
            <span>Gentile Cliente,</span>
          </p>
          <p>
            <span>la Società <b>Greening Energy</b> con sede in Roma (RM), in Via barberini, n. 95, CAP 00187 in qualità di Titolare del trattamento (di seguito, il
              &#8220;<b>Titolare</b>&#8221; o &#8220;<b>Greening Energy</b>&#8221;), La informa delle modalità di gestione dei dati personali che sono
              forniti tramite il sito </span>
            <a href="https://www.greeningenergy.it/">
              <span>https://www.greeningenergy.it/</span>
            </a>
            <span> (di seguito, il
              &#8220;</span>
            <b>
              <span>Sito</span>
            </b>
            <span>&#8221;) e che formano oggetto di trattamento nel rispetto della normativa sopra richiamata. </span>
          </p>
          <p>
            <span>Il Titolare del trattamento è contattabile ai seguenti indirizzi:</span>
            <br>
            <span>&nbsp;&nbsp;- via posta: Via Barberini, 95, 00187 Roma (RM);</span>
            <br>
            <span>&nbsp;&nbsp;- via email: info&#64;greeningenergy.it</span>
          </p>
          <p>
            <span>
              <span>Greening Energy ha nominato un Responsabile della protezione dei dati (c.d. <b>Data Protection Officer</b>)
                contattabile al seguente indirizzo e-mail </span>
            </span>
            <a href="mailto:DPO@greeningenergy.it">
              <span>DPO&#64;greeningenergy.it</span>
            </a>.
          </p>
          <p>
            <b>
              <span>1. Oggetto del trattamento</span>
            </b>
          </p>
          <p>
            <span>Il Titolare pu&#242; trattare i seguenti dati personali</span>
            <br>
            <b>
              <span>Dati ricevuti tramite e-mail o posta</span>
            </b>
            <span>: tra cui, a titolo esemplificativo, nome, cognome, e-mail, numero telefonico, dati contenuti nel
              curriculum vitae e gli ulteriori dati da Lei volontariamente comunicati .
            </span>
          </p>
          <p>
            <b>
              <span>Dati dell'area riservata</span>
            </b>
            <span>: l'accesso all'area riservata del Sito è consentita ai soli clienti registrati tramite il
              profilo di autenticazione e registrazione. Al momento della creazione del profilo sono richiesti alcuni dati personali, quali nome, cognome, indirizzo e-mail, numero di
              cellulare e codice fiscale, necessari per completare con successo la registrazione, accedere nella propria area riservata e fruire dei servizi offerti.</span>
          </p>
          <p>
            <b>
              <span>Dati di navigazione</span>
            </b>
            <span>: i sistemi informatici e telematici e le procedure software preposte al funzionamento e all'utilizzo del sito,
              acquisiscono, nel corso del loro esercizio, alcuni dati (es. la data e l'ora dell'accesso, le pagine visitate, il nome dell'Internet Service Provider e
              l'indirizzo del Protocollo Internet (IP) attraverso il quale accede a Internet, l'indirizzo Internet dal quale lei si è collegato al Sito, ecc.), la cui
              trasmissione è implicita nell'uso dei protocolli di comunicazione web o è utile per la migliore gestione e ottimizzazione del sistema di invio di dati ed
              e-mail. Maggiori informazioni in merito alle procedure eseguite per la raccolta, tramite i cookie e/o altre tecnologie di monitoraggio, delle informazioni fornite durante
              la
              navigazione del Sito sono riportate nella cookie policy disponibile nel sito stesso.</span>
          </p>
          <p>
            <b>
              <span>2. Finalità e basi del trattamento </span>
            </b>
          </p>
          <p>
            <span>Il trattamento dei dati personali è finalizzato a:</span>
            <br>
            <span>1. ricerca e selezione del personale attraverso l'analisi dei curriculum vitae pervenuti tramite e-mail;</span>
            <br>
            <span>2. riscontro a richieste formulate dagli interessati e trasmesse via e-mail o indirizzo di posta;</span>
            <br>
            <span>3. registrazione all'area clienti;</span>
            <br>
            <span>4. manutenzione e funzionamento del sito, compresa la risoluzione di eventuali problemi tecnici.</span>
          </p>
          <p>
            <span>Le basi giuridiche che legittimano il trattamento dei dati personali sono prevista dall'art. 6, paragrafo 1, lett. b) e f) GDPR. ed in particolare, le
              basi giuridiche sono:</span>
            <br>
            <span>&nbsp;&nbsp;- l'esecuzione di misure precontrattuali adottate su richiesta dell'interessato (per le finalità 1 e 2);
            </span>
            <br>
            <span>&nbsp;&nbsp;- l'esecuzione di un contratto di cui l'interessato è parte (per la finalità 3), </span>
            <br>
            <span>&nbsp;&nbsp;- il legittimo interesse del Titolare del trattamento nel caso di manutenzione e funzionamento del sito (per la
              finalità 4).</span>
          </p>
          <p>
            <b>
              <span>3. Natura del dato</span>
            </b>
          </p>
          <p>
            <span>Il conferimento dei Suoi dati personali ha natura obbligatoria, pertanto, l'eventuale rifiuto potrebbe comportare l'impossibilità di
              instaurare e/o proseguire il rapporto contrattuale e/o di dare riscontro alla richiesta ricevuta. </span>
          </p>
          <p>
            <b>
              <span>4. Modalità del trattamento </span>
            </b>
          </p>
          <p>
            <span>Il trattamento dei Suoi dati personali avviene per mezzo di personale debitamente formato in materia di trattamento di dati personali, quali dipendenti,
              collaboratori o consulenti esterni specificamente nominati persone autorizzate o responsabili dal Titolare nell'ambito delle rispettive funzioni o dell'incarico
              professionale conferito. Il trattamento dei Suoi dati personali avviene, anche tramite l'ausilio di strumenti elettronici o, comunque, automatizzati, informatici e
              telematici, ed in ogni caso con logiche strettamente correlate alle finalità sopra menzionate, al fine di garantire la riservatezza e la sicurezza dei dati
              personali.</span>
          </p>
          <p>
            <span>Il Titolare tratta i dati nel rispetto dei principi di liceità, correttezza, trasparenza, esattezza, integrità e non eccedenza, pertinenza e
              necessità rispetto alle finalità perseguite, garantendo la tutela della Sua riservatezza e dei Suoi diritti.</span>
          </p>
          <p>
            <b>
              <span>5. Periodo di conservazione dei dati</span>
            </b>
          </p>
          <p>
            <span>Il Titolare tratterà i dati personali per il tempo necessario per adempiere alle finalità di cui al paragrafo 2 della presente privacy policy. Per
              quanto concerne la ricezione dei curriculum vitae, verranno conservati per massimo 12 mesi dalla ricezione degli stessi, salvo la facoltà del Titolare di richiedere la
              trasmissione del <i>curriculum vitae</i> aggiornato entro tale termine.</span>
          </p>
          <p>
            <b>
              <span>6. Link ad altri siti web</span>
            </b>
          </p>
          <p>
            <span>Il Sito potrebbe includere link a siti web e/o applicazioni di soggetti diversi dal Titolare (di seguito i &#8220;<b>Terzi</b>&#8221;) e accedendo a tali
              siti web e/o applicazioni, i Terzi potrebbero raccogliere informazioni sull'utente quando interagisce con i loro contenuti, la loro pubblicità e i loro servizi alle
              condizioni e termini descritti nei rispettivi siti web /applicazioni. </span>
          </p>
          <p>
            <b>
              <span>7. Destinatari dei dati </span>
            </b>
          </p>
          <p>
            <span>Il Titolare potrà comunicare i Suoi dati ai soggetti ai quali la comunicazione sia obbligatoria per legge o per il perseguimento delle finalità
              indicate al punto 2 della presente privacy policy. In particolare, i Suoi dati potranno essere trasmessi, a titolo esemplificativo, a:</span>
            <br>
            <span>&nbsp;&nbsp;- Agenti o figure esterne che collaborano con l'azienda;</span>
            <br>
            <span>&nbsp;&nbsp;- Banche ed istituti di credito;</span>
            <br>
            <span>&nbsp;&nbsp;- Fornitori di servizi (ad es. fornitori di sistemi IT, fornitori di servizi cloud, fornitori di database e
              consulenti).</span>
          </p>
          <p>
            <span>L'elenco aggiornato dei fornitori nominati Responsabili del trattamento ex art. 28 GDPR è disponibile presso la sede legale del Titolare e
              sarà fornito previa richiesta scritta.</span>
          </p>
          <p>
            <b>
              <span>8. Trasferimento dati </span>
            </b>
          </p>
          <p>
            <span>La gestione e la conservazione dei dati personali avverranno su server ubicati all'interno dell'Unione Europea del Titolare e/o di società
              terze incaricate e debitamente nominate quali Responsabili del trattamento. Attualmente i server sono situati in <span>Italia</span>. I dati non saranno
              oggetto di trasferimento al di fuori dell'Unione Europea. Resta in ogni caso inteso che il Titolare, ove si rendesse necessario, avrà facoltà di spostare
              l'ubicazione dei server in Italia e/o Unione Europea e/o Paesi extra-UE. In tal caso, il Titolare assicura sin d'ora che il trasferimento dei dati extra-UE
              avverrà in conformità alle disposizioni di legge applicabili.</span>
          </p>
          <p>
            <b>
              <span>9. Diritti dell'interessato </span>
            </b>
          </p>
          <p>
            <span>Come previsto dall'art. 13 del GDPR, Lei in ogni momento potrà:</span>
            <br>
            <span>a) chiedere al Titolare del Trattamento l'accesso ai dati personali e la rettifica o la cancellazione degli stessi o la limitazione del Trattamento che lo
              riguardano; </span>
            <br>
            <span>b) opporsi al Trattamento dei Suoi dati personali;</span>
            <br>
            <span>c) esercitare il diritto alla portabilità dei dati;</span>
            <br>
            <span>d) revocare il consenso in qualsiasi momento senza pregiudicare la liceità del Trattamento basata sul consenso prestato prima della
              revoca;</span>
            <br>
            <span>e) proporre reclamo a un'autorità di controllo.</span>
          </p>
          <p>
            <b>
              <span>10. Modalità di esercizio dei diritti </span>
            </b>
          </p>
          <p>
            <span>Potrà in qualsiasi momento esercitare i diritti di cui sopra inviando: </span>
            <br>
            <span>&nbsp;&nbsp;- una raccomandata a.r. a: Società Greening Energy S.r.l., con sede in Roma (RM), in Via Barberini, n. 95, CAP 00187;</span>
            <br>
            <span>&nbsp;&nbsp;- e-mail: info&#64;greeningenergy.it</span>
          </p>
        </div>
      </div>
      <div class="arrow-scroll">
        <button mat-mini-fab (click)="goBottom()" color="primary">
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div fxLayout="column" fxLayoutGap="10px">
        <p>Letta e compresa l'Informativa Privacy, il Cliente:</p>
        <mat-radio-group formControlName="consensoDati" fxFlex fxLayout="row" fxLayoutGap="10px">
          <mat-radio-button [value]="true">Acconsente</mat-radio-button>
          <mat-radio-button [value]="false">Nega il consenso</mat-radio-button>
        </mat-radio-group>
        <p>al trattamento dei propri dati personali per le finalita di marketing come indicate al paragrafo 2.2 sia con ricorso agli strumenti tradizionali di contatto che con ricorso agli
          strumenti automatizzati di contatto ivi descritti.</p>
      </div>
    </div>
  </ng-container>

</form>
